<script setup>
defineProps({
  open: Boolean,
  image: {
    type: String,
    default: ''
  }
})

defineEmits(['close', 'share'])
</script>

<template>
  <section class="dialog snapshot-dialog" :class="{ 'is-open': open }" :aria-hidden="!open">
    <h2>空间截图</h2>
    <img :src="image" alt="模型截图" />
    <p>长按图片保存，或使用系统分享。</p>
    <div>
      <button type="button" @click="$emit('close')">完成</button>
      <button class="is-primary" type="button" @click="$emit('share')">分享图片</button>
    </div>
  </section>
</template>
